import React from 'react';

const CardBottomRight = ({color}) => {
  return (
    <div className="cardBottomRight" style={{ backgroundColor: color }} ></div>
  );
};

export default CardBottomRight;
